const actions = {
	SET_DEPENDENTS: "SET_DEPENDENTS"
};

export default actions;
